export function showSnackbar(dispatch, message, snackbarType)
{
    dispatch({ type: "snackbar/SHOW_SNACKBAR", payload: { message, snackbarType } })
}

export function clearSnackbar(dispatch)
{
    dispatch({ type: "snackbar/CLEAR_SNACKBAR" })
}
